import { render, staticRenderFns } from "./CardDelete.vue?vue&type=template&id=05281a04&"
import script from "./CardDelete.vue?vue&type=script&lang=js&"
export * from "./CardDelete.vue?vue&type=script&lang=js&"
import style0 from "./CardDelete.vue?vue&type=style&index=0&id=05281a04&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports